import { useQuery } from "react-query";
import { getExecutionHistory } from "../../../../actions/Utilities/JobConfig";

const useGetExecutionHistoryByJobId = (jobConfigId) => {
  return useQuery(
    ["getExecutionHistory", jobConfigId],
    () => getExecutionHistory(jobConfigId),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetExecutionHistoryByJobId;
